<template>
    <div :class="className + ' form-group'">
        <label :for="id">{{ label }}</label>
        <textarea :name="name" class="form-control" :id="id" :rows="rows" :required="required" :placeholder="placeholder"/>
    </div>
</template>

<script>
    export default {
        name: "TextArea",
        props: {
            label: String,
            placeholder: String,
            name: String,
            id: String,
            rows: 3,
            helpText: String,
            className: '',
            required: false,
            validate: true
        }
    }
</script>

<style scoped>

</style>
